import { Component, EventEmitter, inject, OnInit, Output } from "@angular/core";
import { FormControl, FormGroup } from '@angular/forms';
import { getFormData } from 'src/app/shared/helpers/utils';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { WithdrawFund } from 'src/app/shared/interfaces/withdraw-fund-response.interface';
import Swal from 'sweetalert2';
import { ORIGINATOR_ID } from 'src/app/shared/enums/common.enum';
import { HttpService } from 'src/app/services/http.service';
import { cloneDeep } from 'lodash';
import { BehaviorSubject } from 'rxjs';
import { UserDetailsFormProvider } from "../../common/providers/userDetail-form-provider";
import { SpinnerService } from "../../../shared/services/spinner.service";
import { UserHttpService } from "../../common/services/user-http.service";

@Component({
  selector: 'app-add-user',
  templateUrl: './add-user.component.html',
  styleUrls: ['./add-user.component.scss'],
})
export class AddUserComponent implements OnInit {
  userForm: FormGroup;
  isSubmitted = false;
  userData: any;
  originatorId = ORIGINATOR_ID;
  readonly #spinnerService = inject(SpinnerService);
  readonly #userHttpService = inject(UserHttpService);

  isLoading$ = new BehaviorSubject<boolean>(false);
  constructor(
    private userFormProvider: UserDetailsFormProvider,
    public activeModal: NgbActiveModal,
    private http: HttpService,
  ) {}

  get phoneGroup(): FormGroup {
    return this.userForm.get('phone') as FormGroup;
  }

  get passwordCtrl(): FormControl {
    return this.userForm.get('password') as FormControl;
  }

  ngOnInit(): void {
    this.userForm = this.userFormProvider.initFormAddNewUser(this.userData);
  }

  onSubmit() {
    this.isSubmitted = true;
    if (this.userForm.invalid) {
      return;
    }

    this.#spinnerService.setShowSpinner(true);
    const rawData = getFormData(this.userForm.value);
    const dto = this.serializeData(rawData);
    this.userData?.id ? this.doUpdate(dto) : this.doCreate(dto);
  }

  onSelect(event: any): void {
    this.isSubmitted = false;
  }

  doCreate(dto: any): void {
    this.isLoading$.next(true);
    this.http.postData('users', dto).subscribe({
      next: (response: any) => {
        this.isLoading$.next(false);
        this.#spinnerService.setShowSpinner(false);
        this.activeModal.close(true);
        this.userForm.reset();
        Swal.fire({
          icon: 'success',
          text: 'User successfully added.',
          showConfirmButton: false,
          timer: 5000,
        });
      },
      error: (error) => {
        this.isLoading$.next(false);
        this.#spinnerService.setShowSpinner(false);
        Swal.fire({
          icon: 'error',
          text: error.error.details || error.error.message,
          showConfirmButton: true,
          confirmButtonText: 'Ok',
        });
      },
    });
  }

  doUpdate(dto: any): void {
    this.isLoading$.next(true);
    this.#userHttpService.updateUser({id: this.userData.id, data: dto }).subscribe({
      next: (response: any) => {
        this.isLoading$.next(false);
        this.#spinnerService.setShowSpinner(false);
        this.activeModal.close(true);
        this.userForm.reset();
        Swal.fire({
          icon: 'success',
          text: 'User successfully updated.',
          showConfirmButton: false,
          timer: 5000,
        });
      },
      error: (error) => {
        this.isLoading$.next(false);
        this.#spinnerService.setShowSpinner(false);
        Swal.fire({
          icon: 'error',
          text: error.error.details || error.error.message,
          showConfirmButton: true,
          confirmButtonText: 'Ok',
        });
      },
    });
  }

  closeModal() {
    this.activeModal.dismiss();
  }

  generatePassword(): void {
    this.userForm.get('password')?.setValue(this.generateRandomStr());
  }

  generateRandomStr(length = 8): string {
    const charset =
      'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*()_+=-';
    let retVal = '';
    for (let i = 0, n = charset.length; i < length; ++i) {
      retVal += charset.charAt(Math.floor(Math.random() * n));
    }
    return retVal;
  }

  private serializeData(data: any) {
    const result = cloneDeep(data);
    const phone = result.phone;
    if (phone) {
      result.phoneNumber = `${phone.phoneCountryCode}${phone.phoneAreaCode}${phone.phoneNumber}`;
    }

    delete result.phone;
    return result;
  }
}
